import {
    GET_ORDER_LINE_CHART,
    SET_ORDER_LINE_LOADING,
    REMOVE_ORDER_LINE_LOADING,
    GET_ORDER_LINE,
    SET_ORDER_LINE_DROPDOWN,
    REMOVE_ORDER_LINE_DROPDOWN,
    SET_ORDER_LINE_SKELETON,
    SET_ORDER_LINE_FIELDS
} from "../types";

const initialState = {
    loading: false, // Initit loading state
    chartData: {}, // contains chart data
    dropdowns: {}, //	Dropdown list
    data: {}, //    Any default vaule here is used for order line items,
    fields: {},
    orderLineSkeleton: {}
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_ORDER_LINE_CHART:
            return {
                ...state,
                chartData: payload.byDay,
                chartLoading: false
            };
        case SET_ORDER_LINE_LOADING:
            return {
                ...state,
                loading: true
            };
        case REMOVE_ORDER_LINE_LOADING:
            return {
                ...state,
                loading: false
            };
        case GET_ORDER_LINE:
            return {
                ...state,
                data: { ...payload }
            };
        case SET_ORDER_LINE_DROPDOWN:
            return {
                ...state,
                dropdowns: { ...payload }
            };
        case REMOVE_ORDER_LINE_DROPDOWN:
            return {
                ...state,
                dropdowns: {}
            };
        case SET_ORDER_LINE_FIELDS:
            return {
                ...state,
                fields: { ...payload }
            };
        case SET_ORDER_LINE_SKELETON:
            return {
                ...state,
                orderLineSkeleton: { ...payload }
            };
        default:
            return state;
    }
}